module.exports = __webpack_public_path__ + "img/quicktips9.210af589.svg";